import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c5b7aac")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")

  return (_openBlock(), _createBlock("div", {
    class: "element-create-selection",
    ref: "selectionRef",
    onMousedown: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.createSelection($event), ["stop"]))
  }, [
    (_ctx.start && _ctx.end)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ['selection', _ctx.creatingElement.type],
          style: _ctx.position
        }, [
          (_ctx.creatingElement.type === 'line' && _ctx.lineData)
            ? (_openBlock(), _createBlock(_component_SvgWrapper, {
                key: 0,
                overflow: "visible",
                width: _ctx.lineData.svgWidth,
                height: _ctx.lineData.svgHeight
              }, {
                default: _withId(() => [
                  _createVNode("path", {
                    d: _ctx.lineData.path,
                    stroke: "#d14424",
                    fill: "none",
                    "stroke-width": "1",
                    "stroke-linecap": "",
                    "stroke-linejoin": "",
                    "stroke-miterlimit": ""
                  }, null, 8, ["d"])
                ]),
                _: 1
              }, 8, ["width", "height"]))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true)
  ], 544))
})